import { DateRangePicker, DateRangePickerProps } from '@mantine/dates';
import 'dayjs/locale/pt-br';

export function CustomDateRangePicker(props: DateRangePickerProps) {
  return <DateRangePicker locale="pt-br" mb={16} {...props} />;
}
